<template>
    <div>
        <pagamento 
            :pagamento="pagamento"
            :pagamentosServicos="obterPagamentosServicos()"
        >
            <template slot="footer">
                <app-btn-voltar></app-btn-voltar>
            </template>
        </pagamento>
        <etapas
            :etapas="etapasDisponiveis"
            :incluirSelecao="true"
            titulo="Etapas Disponíveis"
        >
            <template slot="botoes">
                <b-button-group class="float-right">
                    <b-button
                        variant="primary"
                        @click="confirmaAssociarSelecionadas()"
                        :disabled="etapasDisponiveisSelecionadas.length === 0"
                        ><i class="fa fa-plus"></i> Associar
                        selecionadas</b-button
                    >
                </b-button-group>
            </template>
            <template slot="etapaSelecao" slot-scope="data">
                <b-form-checkbox
                    :value="data.etapaId"
                    v-model="etapasDisponiveisSelecionadas"
                ></b-form-checkbox>
            </template>
        </etapas>
    </div>
</template>

<script>
import Pagamento from './PagamentoDetalhar'
import Etapas from './../etapas/Etapas2'

export default {
    props: {
        pagamentosServicos: {
            type: Object,
            default: () => ({})
        },

        pagamento: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            etapasDisponiveisSelecionadas: [],
            etapasDisponiveis: []
        }
    },

    methods: {
        obterEtapasDisponiveis() {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos
                .obterEtapasDisponiveis(this.$route.params.pagamentoId)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.etapasDisponiveis = response.data
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        confirmaAssociarSelecionadas() {
            this.$swal({
                title: 'Associação de Etapas',
                html: `Confirma a associação das etapas selecionadas?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.associar()
                }
            })
        },

        associar() {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos
                .associarEtapas({
                    pagamentoId: this.$route.params.pagamentoId,
                    etapasId: this.etapasDisponiveisSelecionadas
                })
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro salvo com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.etapasDisponiveisSelecionadas = []
                            this.obterEtapasDisponiveis()
                            this.$emit('obterPagamentoAtualizado')
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        obterPagamentosServicos() {
            return this.pagamentosServicos
        }
    },

    created() {
        this.obterEtapasDisponiveis()
    },

    components: {
        Etapas,
        Pagamento
    }
}
</script>
